import { makeFetchTransport, makeMultiplexedTransport } from '@sentry/browser';

export const MF_DSN_KEY = 'ROUTE_TO';

export const mfSentryTransport = makeMultiplexedTransport(makeFetchTransport, ({ getEvent }) => {
  const event = getEvent();

  if (event?.extra && MF_DSN_KEY in event.extra && Array.isArray(event.extra[MF_DSN_KEY])) {
    return event.extra[MF_DSN_KEY];
  }

  return [];
});
